import React from 'react';
import './LocationSelectTrigger.less';
import {DrawerTrigger} from '../drawer-trigger/DrawerTrigger';

export const LocationSelectTrigger = ({currentLocationName, onClick}) => {
	return <DrawerTrigger caption={currentLocationName} onClick={onClick}/>;
};
